import script from "./NotesTable.vue?vue&type=script&setup=true&lang=js"
export * from "./NotesTable.vue?vue&type=script&setup=true&lang=js"

import "./NotesTable.vue?vue&type=style&index=0&id=2340f4ff&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2340f4ff"]])

export default __exports__